module.exports = __webpack_public_path__ + "img/Doc07_20100094-003_1.af570404.jpg";